import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';

export class VideoPlayerEventTracking extends BaseEventTracking {
  videoIdentifier?: string;

  constructor(eventProperties: Partial<VideoPlayerEventTracking> = {}) {
    super();

    this.videoIdentifier = eventProperties.videoIdentifier;
  }
}
